import { TourExpenseDto } from '@/features/dashboard/expenses/types/TourExpenseDto.ts';

/**
 * Ile z faktury jeszcze nie jest pokryte. Jedno miejsce, bo tę samą liczbę
 * pokazują trzy modale i każda zmiana definicji „pozostało” musi ich dotknąć naraz.
 * Bierze samą parę pól, żeby wiersz listy liczył „pozostało” tak samo jak szczegół.
 */
export const remainingToPay = (
  expense: Pick<TourExpenseDto, 'amount' | 'paidAmount'>,
): number => expense.amount.amount - expense.paidAmount;
